import type { PerUnitPricing } from '@vy/types';
import { safeDivision } from '@vy/utils';

export function getRateMultiplierAdjustedPerUnitPricing(
  pricing: PerUnitPricing,
  rateMultiplier: number,
): PerUnitPricing {
  return {
    ...pricing,
    priceConfiguration: {
      price: safeDivision(pricing.priceConfiguration.price, rateMultiplier),
      chunkSize: pricing.priceConfiguration.chunkSize,
      isMeteredCredit: pricing.priceConfiguration.isMeteredCredit,
    },
  };
}
